import getConfig from 'next/config';
var publicRuntimeConfig = getConfig().publicRuntimeConfig;
var assetsPrefix = publicRuntimeConfig.app.assets.prefix;
export var STATIC_ASSETS_BASE = assetsPrefix;
// For Facebook insights
export var FB_APP_ID = '237843743897';
// For Twitter card configuration
export var TWITTER_SITE = '@redbubble';
export var STOCK_STATUS_STRUCTURED_DATA = {
    'in-stock': 'https://schema.org/InStock',
    'out-of-stock': 'https://schema.org/OutOfStock',
    presale: 'https://schema.org/Presale',
};
